import { jsxs as f, jsx as r } from "react/jsx-runtime";
import { E as g, S as v } from "./icons.types-0722eef5.js";
function m({ title: i, titleId: o, size: c, width: a, height: n, extended: s = !1, ...h }) {
  const l = s ? g : v, t = c ? l[c] : a || l[s ? "s" : "l"], e = c ? l[c] : n || l[s ? "s" : "l"];
  return /* @__PURE__ */ f(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 32 32",
      width: t,
      height: e,
      "aria-labelledby": o,
      ...h,
      children: [
        i ? /* @__PURE__ */ r("title", { id: o, children: i }) : null,
        /* @__PURE__ */ r(
          "path",
          {
            fill: "currentColor",
            d: "M8.41 28.666a2.326 2.326 0 0 1-1.71-.7 2.326 2.326 0 0 1-.7-1.71V5.744c0-.674.233-1.244.7-1.71a2.327 2.327 0 0 1 1.71-.7h10.164c.362 0 .704.075 1.026.226.322.151.594.368.815.65l5.016 6.018c.18.222.32.463.42.725.099.262.149.536.149.821v14.072c0 .541-.247.912-.74 1.112-.493.2-.93.111-1.309-.268l-5.464-5.424c-.378.254-.77.439-1.176.557A4.683 4.683 0 0 1 16 22c-1.283 0-2.382-.457-3.296-1.371-.914-.914-1.37-2.013-1.37-3.296s.456-2.382 1.37-3.296c.914-.914 2.013-1.37 3.296-1.37s2.382.457 3.296 1.37c.914.914 1.37 2.013 1.37 3.296 0 .486-.06.931-.183 1.337a4.2 4.2 0 0 1-.55 1.15L24 23.954V11.6l-5.267-6.267H8.41a.392.392 0 0 0-.282.128.392.392 0 0 0-.128.283v20.512c0 .103.043.197.128.282.086.086.18.129.282.129h11.293c.333 0 .583.103.75.311.166.208.25.437.25.686 0 .25-.084.479-.25.688-.167.21-.417.314-.75.314H8.41ZM16 20c.733 0 1.361-.261 1.883-.783.523-.523.784-1.15.784-1.884 0-.733-.262-1.36-.784-1.883A2.568 2.568 0 0 0 16 14.667c-.733 0-1.361.26-1.883.783a2.568 2.568 0 0 0-.784 1.883c0 .734.261 1.361.784 1.884.522.522 1.15.783 1.883.783Z"
          }
        )
      ]
    }
  );
}
export {
  m as FileSearch
};
